//Paquetes NPM de GYF. 
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, LogsProxy } from 'com-gyf-webcore-servicehub';

//Exportación de constantes - MenuProductos
export const GET_MENU_USUARIO_DATA = 'GET_MENU_USUARIO_DATA';
export const GET_MENU_USUARIO_DATA_SUCCESS = 'GET_MENU_USUARIO_DATA_SUCCESS';
export const GET_MENU_USUARIO_DATA_FAILURE = 'GET_MENU_USUARIO_DATA_FAILURE';
export const RESET_MENU_PRODUCTOS = 'RESET_MENU_PRODUCTOS';
export const SET_PROGRAMA_ACTUAL = 'SET_PROGRAMA_ACTUAL';
export const INITIAL_PRODUCTO_SELECTED_TOP_MENU = 'INITIAL_PRODUCTO_SELECTED_TOP_MENU';
export const POP_UP_OPEN = 'POP_UP_OPEN';
export const POP_UP_PRODUCTO_SELECTED = 'POP_UP_PRODUCTO_SELECTED';
export const POP_UP_PROGRAMA_OPEN = 'POP_UP_PROGRAMA_OPEN';
export const POP_UP_PROGRAMA_CLOSE = 'POP_UP_PROGRAMA_CLOSE';
export const INITIAL_PROGRAM_SELECTED_TOP_MENU = 'INITIAL_PROGRAM_SELECTED_TOP_MENU';
export const INITIAL_PROGRAM_SAVE_TOP_MENU = 'INITIAL_PROGRAM_SAVE_TOP_MENU';
export const ACCESO_DIRECTO_POP_UP_PROGRAMA = 'ACCESO_DIRECTO_POP_UP_PROGRAMA';
export const SET_FLAG_ACCESO_DIRECTO = "SET_FLAG_ACCESO_DIRECTO"

//Exportación de constantes - MenuCategorias
export const SET_CATEGORIAS = 'SET_CATEGORIAS';

//Exportación de constantes - Sesion
export const LOGOUT = 'LOGOUT';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

/**
 *  Action que obtiene el menu del usuario.
 * @param {any} UserId - Id del usuario.
 */
export function getMenuByUsuario(UserId) {
    LogHelper.In(getMenuByUsuario.name, UserId);

    return (dispatch, getState) => {

        dispatch({ type: GET_MENU_USUARIO_DATA });

        var params = {
            "USUARIO_ID": UserId
        };

        Engine1Proxy.AddRuleRequests(params, 'GetInitialData', 'Concierge', 'SEGURIDAD', 'SEGURIDAD');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_MENU_BY_USUARIO_ID', 'Get', 'Concierge', 'Seguridad', 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_ROUTE_BY_USUARIO_ID', 'Get', 'Concierge', 'Seguridad', 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_PRODUCTO_USUARIO_LOGIN', 'Get', 'Concierge', 'Seguridad', 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_CONFIGURATION_PASSWORD_TYPE', "Get", 'Concierge', "SEGURIDAD", 1, 'User');

        LogHelper.Out(getMenuByUsuario.name, dispatch);
        Engine1Proxy.Execute((data) => getMenuByUsuarioCallback(data, dispatch));
    }
}

/** 
 * Action que obtiene las categorias asociadas a un producto.
 * @param {any} productoActual - El productoActual para obtener categorías.
 */
export function getCategoriasByProducto(productoActual) {
    LogHelper.In(getCategoriasByProducto.name, productoActual);

    return (dispatch, getState) => {
        const state = getState();

        //Obtengo la porción de menú correspondiente al producto seleccionado actualmente.
        let categorias = state.menuProductos.menuUsuario.filter(
            x => x.codigo.toUpperCase() === productoActual.toUpperCase()
        );

        if (categorias.length > 0) {
            if (categorias[0].categorias != undefined)
                categorias = categorias[0].categorias;
        }/* else {
            // TODO: usar redirect de react-router.
            _notFoundRedirect("PRODUCT");
        }*/

        LogHelper.Out(getCategoriasByProducto.name, SET_CATEGORIAS, categorias);
        dispatch({ type: SET_CATEGORIAS, data: categorias });
    }
}

/**
 * Action que ejecuta el cierre de sesion al apretar el botón.
 */
export function cerrarSesion() {
    LogHelper.In(cerrarSesion.name);

    return (dispatch, getState) => {
        let state = getState();

        var logoutRequest = {
            "UserId": state.sesion.userId,
            "TipoPlataformaId": 2,
            "TerminalId": state.sesion.executionContext.terminalId
        };        

        LogHelper.Out(cerrarSesion.name, ConciergeProxy.Execute.name);
        LogsProxy.SaveOperationLog("SEGURIDAD,LOGOUT", "Salida del Sistema", null, null, null, null, null, "SEGURIDAD");
        ConciergeProxy.Execute((data) => cerrarSesionCallback(data, dispatch), null, "LOGOUT", logoutRequest, "SEGURIDAD");
    }
}

/**
 * Guarda en el estado el programa al cual se routea
 * @param {any} programaActual
 */
export function setCurrentProgram(programaActual) {
    LogHelper.In(setCurrentProgram.name, programaActual);

    return (dispatch) => {
        LogHelper.Out(setCurrentProgram.name, LogsProxy.SaveOperationLog.name, programaActual);

        LogsProxy.SaveOperationLog("SEGURIDAD,ACCESO,PROGRAMA", "Ingreso al programa " + programaActual /*CODIGO + ' - ' + DESCRIPCION*/,
            null, null, (data) => logProgramCallback(data, dispatch, programaActual), null, null, "SEGURIDAD");               
    }
}

/**
 * 
 * @param {any} productId
 */
export function productoSelected(productId) {
    return (dispatch) => {
        dispatch({ type: INITIAL_PRODUCTO_SELECTED_TOP_MENU, productId: productId});
    }
}

/**
 * 
 */
export function showPopUp() {
    return (dispatch) => {
        $("#productoModal").modal('toggle');
        dispatch({ type: POP_UP_OPEN });
    }
}

/**
 * 
 */
export function showPopUpPrograma() {
    return (dispatch) => {
        $("#productoModal").modal('hide');
        $("#programaModal").modal('show');

        dispatch({ type: POP_UP_PROGRAMA_OPEN });
    }
}

/**
 * 
 * @param {any} productoId
 * @param {any} userId
 * @param {any} startUpSelected
 */
export function programSelectionCancel(productoId, userId, startUpSelected) {
    return (dispatch) => {
        let params = {
            'PRODUCT_ID': productoId,
            'CATEGORY_ID': null,
            'USER_ID': userId
        };

        if (!startUpSelected) {
            Engine1Proxy.AddRuleRequests(params, 'CreateUsuarioInicio', 'Concierge', 'SEGURIDAD', 'SEGURIDAD');
            Engine1Proxy.Execute((data) => createUsuarioInicioCallback(data, dispatch, userId));
        }
        else {
            Engine1Proxy.AddRuleRequests(params, 'UpdateUsuarioInicio', 'Concierge', 'SEGURIDAD', 'SEGURIDAD');
            Engine1Proxy.Execute((data) => createUsuarioInicioCallback(data, dispatch, userId));
        }
    }
}

/**
 * 
 * @param {any} productList
 * @param {any} productId
 */
export function productoSelectedSave(productList, productId) {
    return (dispatch) => {
        dispatch({ type: POP_UP_PRODUCTO_SELECTED, productList: productList, productId: productId });
    }
}

/**
 * 
 * @param {any} productoId
 * @param {any} categoryId
 * @param {any} userId
 * @param {any} startUpSelected
 */
export function programaSelectedSave(productoId, categoryId, userId, startUpSelected) {
    return (dispatch) => { 
        let params = {
            'PRODUCT_ID': productoId,
            'CATEGORY_ID': categoryId,
            'USER_ID': userId
        };

        if (!startUpSelected) {
            Engine1Proxy.AddRuleRequests(params, 'CreateUsuarioInicio', 'Concierge', 'SEGURIDAD', 'SEGURIDAD');
            Engine1Proxy.Execute((data) => createUsuarioInicioCallback(data, dispatch, userId));
        }
        else {
            Engine1Proxy.AddRuleRequests(params, 'UpdateUsuarioInicio', 'Concierge', 'SEGURIDAD', 'SEGURIDAD');
            Engine1Proxy.Execute((data) => createUsuarioInicioCallback(data, dispatch, userId));
        }
    }
}

/**
 * 
 * @param {any} defaultProducto
 */
export function accesoDirectoPopUpPrograma(defaultProducto) {
    LogHelper.In(accesoDirectoPopUpPrograma.name);

    return (dispatch) => {
        dispatch({ type: ACCESO_DIRECTO_POP_UP_PROGRAMA, defaultProducto: defaultProducto  });
    }
}

/**
 * 
 * @param {any} categorySelected
 */
export function programaSelected(categorySelected) {
    return (dispatch) => {
        dispatch({ type: INITIAL_PROGRAM_SELECTED_TOP_MENU, categorySelected: categorySelected});
    }
}

export function setFlagAccesoDirecto() {

    return (dispatch) => {
        dispatch({ type: SET_FLAG_ACCESO_DIRECTO });
    }
}

/* --------------------------------------------- FUNCIONES AUXILIARES --------------------------------------------- */

/**
 * Callback de la ejecución de getMenuByUsuario.
 * @param {any} data
 * @param {any} dispatch
 */
function getMenuByUsuarioCallback(data, dispatch) {
    LogHelper.In(getMenuByUsuarioCallback.name, data, dispatch);

    let initialData = JSON.parse(data.GetInitialData);

    LogHelper.Out(getMenuByUsuarioCallback.name, data, dispatch);
    dispatch({ type: GET_MENU_USUARIO_DATA_SUCCESS, data: data });
}

/**
 * Callback de la creacion del programa asociado al login del usuario
 * @param {any} data
 * @param {any} dispatch
 */
function createUsuarioInicioCallback(data, dispatch, userId) {
    let paramConsulta = {
        'USUARIO_ID': userId
    };

    Engine1Proxy.AddRuleRequests(paramConsulta, 'UpdateUsuarioPrimerLogin', 'Concierge', 'SEGURIDAD', 'SEGURIDAD');
    Engine1Proxy.AddDataSourcesRequests(paramConsulta, 'GET_ROUTE_BY_USUARIO_ID', 'Get', 'Concierge', 'Seguridad', 1, 'User');
    Engine1Proxy.Execute((data) => getRouteInicioCallback(data, dispatch));
}

/**
 * 
 * @param {any} data
 * @param {any} dispatch
 */
function getRouteInicioCallback(data, dispatch) {
    LogHelper.In(createUsuarioInicioCallback.name, data, dispatch);

    $("#programaModal").modal('toggle');
    dispatch({ type: INITIAL_PROGRAM_SAVE_TOP_MENU, data: data });
}

/**
 * 
 * @param {any} data
 * @param {any} dispatch
 */
function createUsuarioInicioCancellCallback(data, dispatch) {
    $("#programaModal").modal('toggle');
    dispatch({ type: POP_UP_PROGRAMA_CLOSE });
}

/**
 * Callback de cerrado de sesión.
 * @param {any} data
 * @param {any} dispatch
 */
function cerrarSesionCallback(data, dispatch) {
    LogHelper.In(cerrarSesionCallback.name, data, dispatch);    

    //Dispatch del logout.
    //TODO: Hasta la posible unificacion de los reducers en la sesion. Podria ser mas ordenado que la disposicion actual.

    //Antes de llamar a logout borro la cookie o el item de localStorage de executionContext para evitar una validación invalida.
    (webStorageMethod == "LOCALSTORAGE") ? localStorage.setItem("_executionContext", "") : document.cookie = "_executionContext" + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    LogHelper.Out(cerrarSesionCallback.name, RESET_MENU_PRODUCTOS, LOGOUT);

    dispatch({ type: RESET_MENU_PRODUCTOS });
    dispatch({ type: LOGOUT });

    //TODO: Actualizar menu al hacer logout sin relodear la pantalla.
}

/**
 * Callback del logeo de la entrada a un nuevo programa
 * @param {any} data
 * @param {any} dispatch
 * @param {any} programaActual
 */
function logProgramCallback(data, dispatch, programaActual) {
    LogHelper.In(logProgramCallback.name, data, dispatch, programaActual);

    LogHelper.Out(logProgramCallback.name, SET_PROGRAMA_ACTUAL, logProgramCallback);
    dispatch({ type: SET_PROGRAMA_ACTUAL, programaActual });
}


// WEBPACK FOOTER //
// ./Portico/App/Screens/TopMenu/Actions.jsx